import Portfolio from "../../componets/Portfolio";

export default function Section1() {
  return (
    <div className="Section1 h-[30vh] xl:h-[60vh]">
      <Portfolio
        bgImage={"assets/banner-image-hosting-cloud.jpg"}
        objectPosition={"object-center"}
        customer={false}
        altText="Hosting And Cloud Services Background Image"
      />
    </div>
  );
}
